import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, ShieldCheck, Truck, CreditCard, Headphones } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="mt-16 bg-slate-900 text-slate-300">
      <div className="border-b border-slate-800">
        <div className="mx-auto grid max-w-7xl grid-cols-2 gap-6 px-6 py-8 md:grid-cols-4">
          {[
            { icon: Truck, t: "Livraison rapide", s: "France & Benelux" },
            { icon: ShieldCheck, t: "Paiement sécurisé", s: "Via Stripe" },
            { icon: CreditCard, t: "Prix TTC", s: "Tout compris" },
            { icon: Headphones, t: "Service client", s: "À votre écoute" },
          ].map((f, i) => (
            <div key={i} className="flex items-center gap-3">
              <f.icon className="h-7 w-7 text-blue-400" />
              <div>
                <p className="text-sm font-semibold text-white">{f.t}</p>
                <p className="text-xs text-slate-400">{f.s}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-6 py-12 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-2">
            <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-blue-600 font-head text-lg font-extrabold text-white">JC</div>
            <span className="font-head text-xl font-extrabold text-white">BOUTIK</span>
          </div>
          <p className="mt-4 max-w-xs text-sm text-slate-400">
            Votre boutique en ligne d'électroménager, cuisine, maison & déco. Des milliers de produits à petits prix.
          </p>
        </div>

        <div>
          <h4 className="font-head text-sm font-bold uppercase tracking-wide text-white">Contact</h4>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <MapPin className="mt-0.5 h-4 w-4 flex-shrink-0 text-blue-400" />
              <span>5 rue des enclos<br />35350 La Gouesnière</span>
            </li>
            <li className="flex items-center gap-2">
              <Mail className="h-4 w-4 flex-shrink-0 text-blue-400" />
              <a href="mailto:contact@jcentreprise.com" className="hover:text-white" data-testid="footer-email">
                contact@jcentreprise.com
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-head text-sm font-bold uppercase tracking-wide text-white">Navigation</h4>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/" className="hover:text-white">Accueil</Link></li>
            <li><Link to="/catalogue" className="hover:text-white">Tous les produits</Link></li>
            <li><Link to="/catalogue?featured=1" className="hover:text-white">Offres du moment</Link></li>
            <li><Link to="/compte" className="hover:text-white" data-testid="footer-account">Mon compte</Link></li>
            <li><Link to="/livraison" className="hover:text-white" data-testid="footer-livraison">Livraison</Link></li>
            <li><Link to="/cgv" className="hover:text-white" data-testid="footer-cgv">CGV</Link></li>
            <li><Link to="/mentions-legales" className="hover:text-white" data-testid="footer-mentions">Mentions légales</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-slate-800 py-5">
        <p className="mx-auto max-w-7xl px-6 text-center text-xs text-slate-500" data-testid="copyright">
          © {new Date().getFullYear()} JC BOUTIK — JC Entreprise. Tous droits réservés.
        </p>
      </div>
    </footer>
  );
};
